import { useState } from 'react';
import moment from 'moment';
import { Button, ButtonGroup, Grid, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import CalendarViewWeekIcon from '@mui/icons-material/CalendarViewWeek';
import ViewDayOutlinedIcon from '@mui/icons-material/ViewDayOutlined';
import ViewAgendaOutlinedIcon from '@mui/icons-material/ViewAgendaOutlined';

const viewOptions = [
  {
    label: 'Month',
    value: 'dayGridMonth',
    icon: CalendarViewMonthIcon,
  },
  {
    label: 'Week',
    value: 'timeGridWeek',
    icon: CalendarViewWeekIcon,
  },
  {
    label: 'Day',
    value: 'timeGridDay',
    icon: ViewDayOutlinedIcon,
  },
  {
    label: 'Agenda',
    value: 'listWeek',
    icon: ViewAgendaOutlinedIcon,
  },
];

interface Toolbar {
  date: any;
  isMobileView?: any;
  calendarView?: any;
  onDatePrev: () => void;
  onDateToday: () => void;
  onDateNext: () => void;
  onViewChange: (data: any) => void;
}

export const CalendarToolbar = ({ date, isMobileView, calendarView, onDatePrev, onDateToday, onDateNext, onViewChange }: Toolbar) => {
  const [alignment, setAlignment] = useState('dayGridMonth');

  const handleChange = (event: any, value: string) => {
    setAlignment(value ?? alignment);
    onViewChange(value ?? alignment);
  };

  return (
    <Grid container spacing={3} alignItems="center" justifyContent="space-between">
      <Grid item>
        <ButtonGroup size="small">
          <Button className="btn btn-primary btn-sm" onClick={onDatePrev}>
            Prev
          </Button>
          <Button className="btn btn-primary btn-sm" onClick={onDateToday}>
            Today
          </Button>
          <Button className="btn btn-primary btn-sm" onClick={onDateNext}>
            Next
          </Button>
        </ButtonGroup>
      </Grid>
      <Grid item>
        <Typography variant="h5" color="textPrimary">
          {moment(date).format('MMMM YYYY')}
        </Typography>
      </Grid>
      {
        calendarView !== 'timeGridDay' &&
        !isMobileView && (
          <Grid item>
            <ToggleButtonGroup color="primary" value={alignment} exclusive onChange={handleChange} aria-label="Platform">
              {viewOptions.map((viewOption) => {
                const Icon = viewOption.icon;
                return (
                  <Tooltip key={viewOption.value} title={viewOption.label}>
                    <ToggleButton value={viewOption.value}>
                      <Icon />
                    </ToggleButton>
                  </Tooltip>
                );
              })}
            </ToggleButtonGroup>
          </Grid>
        )
      }
    </Grid>
  );
};
